<template>
  <div class="zbjy-box">
    <div class="zbjy-content" v-if="data">
      <!-- 直播间信息 -->
      <div class="zbjy-info-card">
        <div class="zbjy-info-left">
          <span class="zbjy-info-room">{{data.liveName}}</span>
          <span class="zbjy-info-time">{{$t('all.keyongshiduan')}}：{{data.liveDate}} {{data.liveTime}}</span>
        </div>
        <span class="zbjy-info-tag">{{$t('all.youxiao')}}</span>
      </div>
      <!-- 直播类型切换 -->
      <div class="zbjy-type-row">
        <div :class="data.liveType === 1 ? 'zbjy-type-active' : 'zbjy-type'" >{{$t('all.shoujizhibo')}}</div>
        <div :class="data.liveType === 2 ? 'zbjy-type-active' : 'zbjy-type'" >OBS{{$t('all.zhibo')}}</div>
      </div>
      <!-- OBS模式额外显示推流地址和推流码 -->
      <div class="zbjy-item" v-if="data.liveType === 2">
        <span class="zbjy-item-label">{{$t('all.tuiliudizhi')}}</span>
		<div class="zbjy-item-right">
			<span class="zbjy-item-value zbjy-text-green zbjy-text-wrap">{{data.obsUrl}}</span>
			<img class="zbjy-item-right-fuzhi" src="../../../assets/image/fuzhi_18@2x.png" alt="" @click="copyToClipboard(data.obsUrl)"/>
		</div>
      </div>
      <div class="zbjy-item" v-if="data.liveType === 2">
        <span class="zbjy-item-label">{{$t('all.tuiliumamiyao')}}</span>
        <div class="zbjy-item-right">
        	<span class="zbjy-item-value zbjy-text-green zbjy-text-wrap">{{data.obsCode}}</span>
			<img class="zbjy-item-right-fuzhi" src="../../../assets/image/fuzhi_18@2x.png" alt="" @click="copyToClipboard(data.obsCode)"/>
        </div>
      </div>
      <!-- 直播金钥 -->
      <div class="zbjy-item">
        <span class="zbjy-item-label">{{$t('all.zhibojinyao')}}</span>
		<div class="zbjy-item-right">
			<span class="zbjy-item-value zbjy-text-green zbjy-text-wrap">{{data.startKey}}</span>
			<img class="zbjy-item-right-fuzhi" src="../../../assets/image/fuzhi_18@2x.png" alt="" @click="copyToClipboard(data.startKey)"/>
		</div>
      </div>
      <!-- 邮件通知 -->
      <div class="zbjy-item2 zbjy-item-mail">
        <div class="zbjy-item-mail-left">
          <span class="zbjy-item-label">{{$t('all.youjiankuaidi')}}</span>
		  <span class="zbjy-info-tag zbjy-info-tag-click" @click="handleGoMail">{{$t('all.yifasong')}}</span>
        </div>
		<span class="zbjy-item-desc" v-html="data.emailInfo.content.replace(/\n/g, '<br>')"></span>
      </div>
      <!-- 复制全部按钮 -->
      <div class="zbjy-btn" @click="handleCopyAll">{{$t('all.fuzhiquanbu')}}</div>
    </div>
    <!-- 复制成功提示 -->
    <transition name="fade">
      <div class="zbjy-toast" v-if="showToast">{{$t('all.fuzhichenggong')}}</div>
    </transition>
  </div>
</template>

<script>
import { getLiveApplyInfo } from "@/api/zhiboshenqing";
export default {
  data() {
    return {
      showToast: false,
	  data:'',
    };
  },
  mounted() {
    this.getLiveApplyInfo();
  },
  methods: {
	async getLiveApplyInfo(){
		const res = await getLiveApplyInfo({applyId:this.$route.query.applyId})
		this.data = res.data
	},
    handleGoMail() {
	  this.$router.push({ path: '/youjiantongzhi',query: {
	    applyId: this.$route.query.applyId
	  }});
    },
    handleCopyAll() {
      if (!this.data) return;
      let text = '';
      if (this.data.liveType === 2) {
        if (this.data.obsUrl) text += `${this.$t('all.tuiliudizhi')}：${this.data.obsUrl}\n`;
        if (this.data.obsCode) text += `${this.$t('all.tuiliumamiyao')}：${this.data.obsCode}\n`;
      }
      if (this.data.startKey) text += `${this.$t('all.zhibojinyao')}：${this.data.startKey}`;
      if (text) {
        this.copyToClipboard(text);
      }
    },
    copyToClipboard(text) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text).then(() => {
          this.showCopyToast();
        });
      } else {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
        this.showCopyToast();
      }
    },
    showCopyToast() {
      this.showToast = true;
      setTimeout(() => {
        this.showToast = false;
      }, 2000);
    }
  }
};
</script>

<style scoped lang="scss">
@import "./zhibojinyao.css";

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// zhibojinyao.vue?0aa20074